import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import classess from './style.module.css';

export default () => {
	const emailFieldElement = document.querySelector('.field-fastregistrationform-email');

	if (emailFieldElement === null) {
		return;
	}

	const noticeElement = document.createElement('p');
	const noticeText = translator.t('main', 'Check email');

	noticeElement.classList.add(classess.emailNotice);
	noticeElement.textContent = noticeText;
	emailFieldElement.append(noticeElement);
};
